import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-board-error',
  templateUrl: './board-error.component.html',
  styleUrls: ['./board-error.component.scss']
})
export class BoardErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
